/**
 * As colunas da lista de empresas.
 *
 * Fora do presenter pelo mesmo motivo da tabela de colaboradores
 * (`collaborator-table.ts`): e a descricao da tabela, e nao ciclo de vida. Aqui
 * tambem e o unico lugar onde vive a lista branca de ordenacao, que as keys leem
 * para validar o que chega pela URL - se ficasse no presenter, as keys teriam de
 * importar quem as importa.
 */
/**
 * A ordem em que a lista abre - o `defaultOrderBy` do painel antigo (`Companies/index.tsx`).
 * Ausente do endereco de proposito: `sort` vazio significa esta ordem.
 */
export const DEFAULT_SORT = 'cnpj';
/**
 * As colunas na ORDEM e com os rotulos da referencia (`Companies/index.tsx`).
 *
 * `AÇÃO` nao esta aqui porque nao ordena por nada: ela e a ultima coluna, montada
 * pela view, como la (`sortFn: () => 0`).
 *
 * `RAMO DE ATIVIDADE` e `COLABORADORES` vem DEPOIS das da referencia porque sao adicao
 * do porte - assim as cinco primeiras ficam na ordem de la, e o incremento aparece
 * no fim.
 */
export const COLUMNS = [
    { field: 'cnpj', label: 'CNPJ' },
    { field: 'razao', label: 'RAZÃO SOCIAL' },
    { field: 'fantasia', label: 'NOME FANTASIA' },
    { field: 'contato', label: 'CONTATO RESPONSÁVEL' },
    { field: 'status', label: 'STATUS' },
    { field: 'ramo', label: 'RAMO DE ATIVIDADE' },
    { field: 'usuarios', label: 'COLABORADORES' }
];
/**
 * A coluna de ACAO, desenhada pela view: nao ordena por nada e nao tem campo no
 * servidor. O modelo da tabela precisa conhece-la mesmo assim - e uma coluna na tela,
 * com largura -, mas ela nao se estica: so guarda botoes.
 */
export { ACTION_COLUMN } from '../../../../components/table';
/**
 * Os nomes que o `sort` da URL pode ter - a lista branca.
 *
 * O backend tem a dele (`SEARCH_SORTABLE`, no `CompanyService`); esta evita a ida
 * ate la e mantem a tela coerente com o que ela mesma sabe desenhar.
 */
export const SORT_FIELDS = COLUMNS.map((column) => column.field);
//# sourceMappingURL=company-table.js.map